import styled from 'styled-components';
import { Link as router } from 'react-router-dom';
import light from '../../assets/light_mode.svg';
import dark from '../../assets/dark_mode.svg';

export const Menu = styled.div`
  display: grid;
  grid-template-columns: 100px 2fr auto;
  grid-template-rows: 80px;
  align-items: center;
  grid-column: 1 / -1;
  background: var(--secondary);
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  z-index: 1000;
  @media (max-width: 739px) {
    justify-content: center;
    flex-direction: column;
  }
  @media (max-width: 499px) {
    grid-template-columns: 80px 2fr 1fr;
    gap: 10px;
  }
`;

export const Logo = styled.img`
  height: 100%;
  border: 1px solid #bfa63e;
  @media (max-width: 1200px) {
    width: 200px;
  }
`;

export const LogoContainer = styled.div`
  justify-self: center;
`;

export const Account = styled.div`
  color: #fff;
  display: flex;
  flex-direction: row;
  font-size: 1.4rem;
  font-family: 'GothamBold';
  margin-left: 15px;
  align-items: center;
  justify-content: center;
  gap: 15px;
  span {
    margin-right: 15px;
    font-size: 1.4rem;
  }
  @media (max-width: 739px) {
    padding-top: 10px;
    span {
      display: none;
    }
  }
`;

export const ButtonNotification = styled.button`
  background: transparent;
  border: none;
  border-radius: 50%;
  border-color: #ccc;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.3s ease;
  &:hover {
    background: rgba(0, 0, 0, 0.2);
  }
`;

export const ButtonConfig = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  border-color: #ccc;
  color: #fff;
  cursor: pointer;
  display: flex;
  margin-right: 10px;
  transition: 0.3s ease;
  text-align: center;
  vertical-align: center;
  border-radius: 5px;
  transition: 0.3s ease;
  &:hover {
    background: rgba(0, 0, 0, 0.2);
  }
`;

export const Link = styled(router)`
  align-items: center;
  border-radius: 3px;
  color: #fff;
  display: flex;
  text-decoration: none;
`;

export const Checkbox = styled.input`
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  outline: 0;
  cursor: pointer;
  width: 4em;
  height: 1.5em;
  border-radius: 3em;
  background-color: #ebebeb;
  transition: background-color 0.09s ease-in-out;
  position: relative;

  &:active::after {
    background-color: #f2f2f2;
    padding-right: 0.8em;
  }

  &::after {
    content: '';
    width: 3rem;
    height: 3rem;
    background-color: white;
    background-image: url(${dark});
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 3em;
    position: absolute;
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
    transition: left 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),
      padding 0.3s ease, margin 0.3s ease,
      background-image 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 2px 0px 5px 0 rgba(0, 0, 0, 0.15);
  }

  &:checked {
    background-color: #333;
    &:active::after {
      margin-left: -0.8em;
    }
    &::after {
      left: 2.4em;
      background-color: #242424;
      background-image: url(${light});
    }
  }
`;
